import { Injectable, signal } from '@angular/core';
import { RANGE } from './content';

/**
 * Which category of the range is on show in the Collections section. It is
 * shared so that the header's Collections menu can open a category there.
 */
@Injectable({ providedIn: 'root' })
export class RangeTab {
  /** id of a tab in RANGE */
  readonly id = signal(RANGE[0].id);
}
